import React, { useState } from "react";
import styled from "styled-components";
import tick from "../assets/images/checkmark.png";
import { useNavigate } from "react-router-dom";
import { FiCopy } from "react-icons/fi";

const ThankYouPage = () => {
  const navigate = useNavigate();
  const applicationPNR = "FCF547";
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(applicationPNR);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Container>
      <Heading>
        <ArrowImage src={tick} alt="✔" />
        Thank You for Your Passport Application
      </Heading>

      <Message>
        We have received your passport application. Our team will review it and
        get in touch with you within the next 24 hours.
      </Message>

      <PNRSection>
        <PNRLabel>
          Your Application ID : <strong>{applicationPNR}</strong>
        </PNRLabel>
        <CopyWrapper onClick={handleCopy} title="Copy PNR">
          <span>Copy</span>
          <FiCopy size={20} />
          {copied && <CopiedText>Copied..!</CopiedText>}
        </CopyWrapper>
      </PNRSection>

      <Button onClick={() => navigate("/")}>Re-apply</Button>
    </Container>
  );
};

// Styled Components
const Container = styled.div`
  max-width: 700px;
  margin: 50px auto;
  padding: 2rem;
  background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
  border: 1px solid #353535;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  text-align: center;
`;

const Heading = styled.h1`
  color: #e6e6e6;
  font-size: 1.65rem;
  font-weight: 300;
  line-height: 1.3;
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

const ArrowImage = styled.img`
  width: 50px;
  height: 50px;
  margin-right: 10px;
`;

const Message = styled.p`
  font-size: 1.2rem;
  color: #e6e6e6;
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const PNRSection = styled.div`
  background-color: #1e1e1e;
  padding: 1rem 1.5rem;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #e6e6e6;
  flex-wrap: wrap;
  background: #171719;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  border: 1px solid #353535;
  margin-bottom: 2rem;
`;

const PNRLabel = styled.p`
  font-size: 1.1rem;
  margin: 0;
  flex: 1;
  min-width: 220px;
  strong {
    color: #28a745;
  }
`;

const CopyWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: 1rem;

  span {
    color: #3f51ff;
  }

  svg {
    margin-left: 0.5rem;
    color: #3f51ff;
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.2);
    }
  }
`;

const CopiedText = styled.span`
  font-size: 0.9rem;
  color: #76ff03;
  margin-left: 0.5rem;
`;

const Button = styled.button`
  background: linear-gradient(
    90deg,
    rgba(25, 75, 253, 1) 0%,
    rgba(173, 19, 251, 1) 100%
  );
  transition: all 0.3s ease;
  color: #ffffff;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;

  &:hover {
    background-color: #5a189a;
    box-shadow: 0 6px 16px rgba(90, 24, 154, 0.5);
    transform: translateY(-2px);
  }
`;

export default ThankYouPage;
